/**
* @Author: zachalam
* @Date:   2017-04-12T10:38:53-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-04-12T10:38:53-07:00
*/


import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import MTapp from './reducers/index';
import { loadState, saveState } from './localStorage';
import throttle from 'lodash/throttle';

import createLogger from 'redux-logger';
import {jwt} from './jwt';

let existingState = loadState();
let store = createStore(MTapp, existingState, applyMiddleware(jwt, thunk, createLogger()));

// persist reducer state to ls at most every 2 seconds (on reducer change).
store.subscribe(throttle(() => {
  saveState({
    auth: store.getState().auth,
    profile: store.getState().profile,
    billing: store.getState().billing,
    search: store.getState().search,
    meta: store.getState().meta
  });
}, 2000));

export default store;



// WEBPACK FOOTER //
// ./src/store.js